// Readers for the raw index rows every list tool returns (`SELECT *` off
// the `roasts` table). The rows carry `coffee_label` and a JSON-encoded
// `tags_json`, not the friendlier names the pages used to assume.

import type { RoastSummary } from "./types";

// Display name for a row: the coffee label, else the coffee id, else the
// roast's own name, else its id.
export function rowCoffee(r: RoastSummary): string {
  return r.coffee_label || r.coffee_id || r.name || r.roast_id;
}

// `tags_json` is a JSON array string on the wire. Anything that is not a
// well-formed string array reads as no tags — a malformed row should not
// take the whole list down.
export function rowTags(r: RoastSummary): string[] {
  const raw = r.tags_json;
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((t): t is string => typeof t === "string");
  } catch {
    return [];
  }
}
